<template>
  <!-- Slider -->
  <v-sheet color="white" class="activePosition mx-auto">
    <!--Slide Group-->
    <v-slide-group
      v-model="selectedItem"
      class="slider-center mt-2"
      center-active
      show-arrows
      :min="0"
      :max="100"
      :step="10"
    >
      <v-slide-group-item
        v-for="(item, index) in items"
        :key="index"
        v-slot="{ active }"
      >
        <!--single card component-->
        <v-card
          :color="active ? colorSlider : `${colorSlider} lighten-4`"
          class="ma-2"
          height="90"
          width="150"
          @click="!active ? handleItemClick(index) : null"
        >
          <v-row
            class="fill-height d-flex flex-column justify-center align-center"
            no-gutters
          >
            <v-col class="text-center">
              <v-icon
                :color="active ? 'white' : 'white'"
                size="32"
                class="align-end mt-4"
                >{{ item.icon }}</v-icon
              >
            </v-col>
            <v-col>
              <div
                class="text-overline text-center"
                :class="active ? 'text-white' : 'text-white'"
              >
                {{ item.name }}
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
export default {
  props: ["items", "page"],
  data: function () {
    return {
      selectedItem: null,
    };
  },
  mounted() {
    // Add an event listener on select an action type
    document.addEventListener("edit-action-item", this.editSelectedAction);
  },
  beforeUnmount() {
    document.removeEventListener("edit-action-item", this.editSelectedAction);
  },
  computed: {
    colorSlider() {
      return this.page === "assets" ? "primary" : "secondary";
    },
  },
  methods: {
    dispatchSelectedItem(item) {
      document.dispatchEvent(
        new CustomEvent("selected-item-slider", {
          detail: item,
        }),
      );
    },

    //Manage click on every slide badge
    handleItemClick(index) {
      // Toggle active badge
      this.selectedItem = this.selectedItem === index ? null : index;
      // Action to be performed when clicking on the element
      this.dispatchSelectedItem(this.items[index]);
    },
    //Selects the slide badge of the action in editing
    editSelectedAction(e) {
      const index = this.items.findIndex((i) => i.type === e.detail.type);
      this.selectedItem = index;
      this.dispatchSelectedItem(this.items[index]);
      //Dispatch item to edit
      document.dispatchEvent(
        new CustomEvent("item-to-edit", {
          detail: e.detail,
        }),
      );
    },
  },
};
</script>
<style scoped>
.slider-center :deep(.v-slide-group__content) {
  justify-content: center;
}
</style>
